import { sanitize } from "@/utils/sanitize.ts";
import Balancer from "react-wrap-balancer";

/**
 * @deprecated
 */
export const HTMLBalancer = (
  html: string,
  as: string | undefined = undefined,
) => {
  const sanitized = sanitize(html);
  const innerContent = sanitized.replace(
    /^<([a-z][a-z0-9]*)([^>]*)>(.*)<\/\1>$/i,
    "$3",
  );
  return (
    <Balancer dangerouslySetInnerHTML={{ __html: innerContent }} as={as} />
  );
};

// Block-level tags that are NOT valid as descendants of a <p>. If the
// sanitized content contains any of these, the wrapper must be a <div>,
// otherwise the browser auto-closes the <p> and SSR hydration fails.
const BLOCK_LEVEL =
  /<(p|div|ul|ol|li|h[1-6]|table|thead|tbody|tfoot|tr|td|th|blockquote|section|article|aside|header|footer|figure|figcaption|pre|hr|address)\b/i;

export const HTML = (html: string, as: "div" | "p" = "p") => {
  const sanitized = sanitize(html, { addAttributes: ["target"] });
  // For an inline <p> wrapper we strip a single wrapping tag (e.g. the editor's
  // own <p>) so we don't nest <p> inside <p>.
  const inlined = sanitized.replace(
    /^<([a-z][a-z0-9]*)([^>]*)>(.*)<\/\1>$/i,
    "$3",
  );
  // A <p> may only contain phrasing content. If block-level elements remain
  // after unwrapping (e.g. multi-paragraph rich text), render a <div> with the
  // full sanitized markup instead — valid nesting, no hydration mismatch.
  const useBlock = as === "div" || BLOCK_LEVEL.test(inlined);
  const Component = useBlock ? "div" : "p";
  const innerContent = useBlock ? sanitized : inlined;
  return <Component dangerouslySetInnerHTML={{ __html: innerContent }} />;
};
